import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { HideLoader, ShowLoader } from '../../../shared/store/loader/loader.actions';
import { LoaderState } from '../../../shared/store/loader/loader.state';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private store = inject(Store);

  get state() {
    return this.store.selectSnapshot(LoaderState.isLoading);
  }

  show(): void {
    this.store.dispatch(new ShowLoader());
  }

  hide(): void {
    this.store.dispatch(new HideLoader());
  }
}
